import React from "react";
import "../../../preneed-section/payments-and-billing/payment-status.scss";

const statusColors: { [key: string]: string } = {
  pending: "status-pending",
  completed: "status-completed",
  confirmed: "status-approved",
  cancelled: "status-rejected",
};

const formatStatus = (status: string) => {
  if (!status) return "-";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

const OrderStatus: React.FC<{ status: string }> = ({ status }) => {
  const normalized = status?.trim().toLowerCase();

  return (
    <span
      className={`status-badge ${
        statusColors[normalized] || "status-default"
      } table-cell-ellipsis`}
    >
      {formatStatus(status)}
    </span>
  );
};

export default OrderStatus;
